import moment from 'moment'
import React from 'react'

import {
  bindTargetMixin,
  CancelButton,
  RadioGroupInput,
  CheckboxInput,
  DateInput,
  SaveButton,
  SelectInput,
  TextInput,
  TextField,
  NumbersTextInput,
  Validators
} from '../../../shared/FormBuilder'
import { Paper } from '../../../shared/NarusMaterial'

const style = {
  block: {
    maxWidth: 250
  },
  checkbox: {
    width: '100%'
  },
  textField: {
    marginBottom: '1rem',
    marginRight: '.2rem',
    width: '100%'
  },
  inputStyle: {
    width: '100%'
  },
  saveButton: {
    marginLeft: '1rem'
  },
  marg: {
    marginTop: '1rem'
  }
}

const parseDate = d => moment(d, 'MM/DD/YYYY')

class UtilizationExpenseForm extends bindTargetMixin(React.Component) {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  UNSAFE_componentWillMount () {
    this.calculateDays()

    this.setState({
      value: {
        verified: false,
        ...this.state.value
      }
    })
  }

  componentDidUpdate (op, os) {
    if (
      os.value.startDate !== this.state.value.startDate ||
      os.value.stopDate !== this.state.value.stopDate
    ) {
      this.calculateDays()
    }
  }

  getValue () {
    return { ...this.state.value }
  }

  handleSubmit () {
    const { onSubmit } = this.props
    this.setState({ isSubmitting: true })
    onSubmit(this.getValue())
  }

  calculateDays () {
    const start = this.state.value.startDate || null
    const stop = this.state.value.stopDate || null
    if (start && stop) {
      const diff = parseDate(stop).diff(parseDate(start), 'days')
      this.setState({ days: diff + 1 })
    }
  }

  renderAdmission () {
    const ExpTypes = [
      {
        label: 'Saving',
        code: 'Saving'
      },
      {
        label: 'Anticipated Costs',
        code: 'Anticipated Costs'
      },
      {
        label: 'Expense',
        code: 'Expense'
      }
    ]
    const Categories = [
      {
        label: 'Emergency/Urgent Care Avoidance',
        code: 'Emergency/Urgent Care Avoidance'
      },
      {
        label: 'Hospitalization',
        code: 'Hospitalization'
      },
      {
        label: 'Prescription',
        code: 'Prescription'
      },
      {
        label: 'Level of Care',
        code: 'Level of Care'
      },
      {
        label: 'In/Out of Network',
        code: 'In/Out of Network'
      },
      {
        label: 'Over-Utilization',
        code: 'Over-Utilization'
      },
      {
        label: 'Absenteeism',
        code: 'Absenteeism'
      },
      {
        label: 'Contracting / Negotiations',
        code: 'Contracting / Negotiations'
      },
      {
        label: 'Maternity Management',
        code: 'Maternity Management'
      },
      {
        label: 'Care Redirection',
        code: 'Care Redirection'
      },
      {
        label: 'Hemoglobin A1c Reduction',
        code: 'Hemoglobin A1c Reduction'
      },
      {
        label: 'Hypertension Management',
        code: 'Hypertension Management'
      },
      {
        label: 'Weight Loss',
        code: 'Weight Loss'
      },
      {
        label: 'Smoking Cessation',
        code: 'Smoking Cessation'
      },
      {
        label: 'Facility Redirection',
        code: 'Facility Redirection'
      }
    ]
    const hd = [
      {
        label: 'Hard',
        code: 'Hard'
      },
      {
        label: 'Soft',
        code: 'Soft'
      },
      {
        label: 'Other',
        code: 'Other'
      }
    ]

    const { onCancel } = this.props
    return (
      <div className='margin-top margin-bottom'>
        <Paper>
          <div className='row'>
            <div className='col-xs-12 col-sm-4'>
              <SelectInput
                name='type'
                options={ExpTypes.map(a => ({
                  value: a.code,
                  label: a.label
                }))}
                label='Type'
                required
              />
            </div>
            <div className='col-xs-12 col-sm-4'>
              <SelectInput
                name='category'
                options={Categories.map(a => ({
                  value: a.code,
                  label: a.label
                }))}
                label='Category'
                required
              />
            </div>
            <div className='col-xs-12 col-sm-4'>
              <SelectInput
                name='hardSoft'
                noSort
                options={hd.map(a => ({
                  value: a.code,
                  label: a.label
                }))}
                label='Hard/Soft'
                required
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-md-4'>
              <DateInput
                label='Start Date'
                name='startDate'
                required
              />
            </div>
            <div className='col-xs-12 col-md-4'>
              <DateInput
                label='Stop Date'
                name='stopDate'
                validators={[
                  (stopDate, form) => {
                    const { startDate } = form
                    return (
                      parseDate(stopDate).diff(
                        parseDate(startDate),
                        'seconds'
                      ) < 0 && 'Stop date must be greater than start date'
                    )
                  }
                ]}
              />
            </div>
            <div className='col-xs-12 col-md-4'>
              <div className='text-container'>
                <TextField
                  className='nh-textbox'
                  value={this.state.days || 0}
                  disabled
                  label='Days'
                />
              </div>
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12 col-md-4'>
              <NumbersTextInput
                label='Amount, $'
                name='amount'
                validators={[
                  Validators.or(Validators.empty(), Validators.money())
                ]}
              />
            </div>
            <div
              className='col-xs-12 col-md-4'
              style={{ paddingTop: '50px' }}
            >
              <RadioGroupInput
                noClear
                options={[
                  {
                    label: 'Actual',
                    value: 'actual'
                  },
                  {
                    label: 'Estimate',
                    value: 'estimate'
                  }
                ]}
                name='amountType'
              />
            </div>
            <div
              className='col-xs-12 col-md-4'
              style={{ paddingTop: '45px' }}
            >
              <CheckboxInput
                label='Verified'
                name='verified'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-xs-12'>
              <TextInput
                label='Comments'
                name='comments'
              />
            </div>
          </div>

          <div
            className='row end-xs'
            style={style.marg}
          >
            <div className='col-xs-offset-8 col-xs-4'>
              <CancelButton
                noGlobal
                onClick={onCancel}
              />
              <SaveButton
                disabled={this.state.isSubmitting}
                onClick={this.handleSubmit}
              />
            </div>
          </div>
        </Paper>
      </div>
    )
  }

  render () {

    return <div onKeyDown={this.props.onKeyDown}>{this.renderAdmission()}</div>
  }
}

export default UtilizationExpenseForm
